<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item :to="{name: 'DashboardHome'}">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>獎勵應用中心</b-breadcrumb-item>
            <b-breadcrumb-item active>訂單點數設定</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <h4 class="mb-4 text-primary">訂單點數設定</h4>

      <b-overlay
        :show="isLoading || isSubmmiting"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <!-- 訂單來源通路 START -->
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="訂單來源通路"
          label-for="merchant"
        >
          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-if="!isLoading && !isEdit && module.merchant_id !== null"
              v-model="isFormEnabled"
              class="text-nowrap mr-3"
            >設定</b-form-checkbox>
            <b-form-select
              v-model="module.merchant_id"
              @input="fetchModule"
              :options="merchants"
              :disabled="isFetchingMerchants"
              size="sm"
            ></b-form-select>
          </div>
        </b-form-group>
        <!-- 訂單來源通路 END -->

        <b-overlay
          :show="!isFormEnabled"
          opacity="0.6"
          class="spinner-transparent"
          blur="1px"
        >
          <!-- 是否啟用 START -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="是否啟用"
            label-for="isModuleEnabled"
          >
            <div class="d-flex align-items-center h-100">
              <b-form-checkbox
                v-model="module.is_enabled"
              ></b-form-checkbox>
            </div>
          </b-form-group>
          <!-- 是否啟用 END -->
          <!-- 入點會員通路 START -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="入點會員通路"
            label-for="merchantTypes"
          >
            <div class="d-flex align-items-center">
              <b-form-select
                v-model="module.module_config.to_merchant_type"
                :options="merchantTypes"
                size="sm"
              ></b-form-select>
            </div>
          </b-form-group>
          <!-- 入點會員通路 END -->
          <!-- 訂單金額 START -->
          <b-form-group
            label-cols="12"
            label-cols-lg="2"
            label-size="sm"
            label="訂單金額欄位"
          >
            <b-form-select
              v-model="module.module_config.price_column"
              :options="priceColumnOptions"
              size="sm"
              style="width: 150px"
            ></b-form-select>
          </b-form-group>
          <!-- 訂單金額 END -->

          <!-- 訂單入點 START -->
          <section class="row mb-5">
            <div class="col-12 col-xl-10">
              <h4 class="mb-4 text-primary">
                訂單入點
                <i
                  class="fa fa-question-circle ml-2 text-muted"
                  id="order-point-tooltip"
                  style="font-size: 1rem;"
                ></i>
                <b-tooltip target="order-point-tooltip" triggers="hover" placement="right">
                  因訂單成立，系統發放點數予用戶
                </b-tooltip>
              </h4>

              <!-- 條件列表 -->
              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                  <span class="font-weight-bold">訂單條件</span>
                </div>
                <div class="card-body">
                  <div>
                    <h6 class="font-weight-bold">
                      時間範圍
                    </h6>
                  </div>
                  <b-form-group ref="startTimeFormGroup" id="start-time-form-group" class="ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        value="start_time_query"
                        v-model="conditionsCheckboxType"
                      >
                      <div class="m-1">起始時間：</div>
                      <div class="m-1">
                        <b-form-select
                          v-model="startTimeCondition.type"
                          :options="startTimeQueryConditionOptions"
                          :disabled="!conditionsCheckboxType.includes('start_time_query')"
                          size="sm"
                          class="w-auto"
                          style="min-width: 140px"
                        ></b-form-select>
                      </div>
                      <div class="m-1">
                        <b-form-input
                          type="number"
                          :value="startTimeCondition.days"
                          :disabled="!conditionsCheckboxType.includes('start_time_query')"
                          min="0"
                          step="1"
                          size="sm"
                          style="width: 100px"
                          @keydown="preventInvalidNumberKey($event, 0)"
                          @input="onPositiveIntInput($event, 'startTimeCondition.days', 0)"
                        />
                      </div>
                      <div class="m-1">天</div>
                      <i class="fa fa-question-circle ml-2 text-muted" id="start-time-condition-tooltip"></i>
                      <b-tooltip target="start-time-condition-tooltip" triggers="hover" placement="right">
                        特定天數後，處理入點。
                      </b-tooltip>
                    </div>
                    <b-form-invalid-feedback :state="!isTimeRangeInvalid" :force-show="isTimeRangeInvalid" style="margin-left: 20px;">
                      起始時間必須小於截止時間
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group class="mb-3 ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        value="end_time_query"
                        v-model="conditionsCheckboxType"
                      >
                      <div class="m-1">截止時間：</div>
                      <div class="m-1">
                        <b-form-select
                          v-model="endTimeCondition.type"
                          :options="endTimeQueryConditionOptions"
                          :disabled="!conditionsCheckboxType.includes('end_time_query') || (conditionsCheckboxType.includes('start_time_query') && conditionsCheckboxType.includes('end_time_query'))"
                          size="sm"
                          class="w-auto"
                          style="min-width: 140px"
                        ></b-form-select>
                      </div>
                      <div class="m-1">
                        <b-form-input
                          type="number"
                          :value="endTimeCondition.days"
                          :disabled="!conditionsCheckboxType.includes('end_time_query')"
                          min="0"
                          step="1"
                          size="sm"
                          style="width: 100px"
                          @keydown="preventInvalidNumberKey($event, 0)"
                          @input="onPositiveIntInput($event, 'endTimeCondition.days', 0)"
                        />
                      </div>
                      <div class="m-1">天</div>
                      <i class="fa fa-question-circle ml-2 text-muted" id="end-time-condition-tooltip"></i>
                      <b-tooltip target="end-time-condition-tooltip" triggers="hover" placement="right">
                        超過特定天數尚未入點之訂單，將視為失效，不予處理。
                      </b-tooltip>
                    </div>
                  </b-form-group>

                  <b-form-group class="ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        value="gaining_calculation_start_date"
                        v-model="conditionsCheckboxType"
                      >
                      <div class="m-1">
                        <b-form-select
                          v-model="module.module_config.calculation_start_date.gaining.by"
                          :options="calculationStartDateByOptions"
                          :disabled="!conditionsCheckboxType.includes('gaining_calculation_start_date')"
                          size="sm"
                          class="w-auto"
                          style="min-width: 120px"
                        ></b-form-select>
                      </div>
                      <div class="m-1">應晚於：</div>
                      <div class="m-1 d-flex">
                        <AppDatePicker
                          size="sm"
                          v-model="module.module_config.calculation_start_date.gaining.date"
                          :disabled="!conditionsCheckboxType.includes('gaining_calculation_start_date')"
                        />
                      </div>
                    </div>
                  </b-form-group>

                  <hr class="my-4">
                  <div>
                    <div class="d-flex align-items-center mb-3">
                      <h6 class="font-weight-bold mb-0">進階篩選</h6>
                      <small class="text-muted ml-2">設定特定訂單狀態或分店</small>
                    </div>

                    <!-- 訂單狀態 -->
                    <b-form-group class="mb-3 ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="conditionsCheckboxType_order_status"
                        class="form-check-input"
                        value="order_status_filter"
                        v-model="conditionsCheckboxType">
                      <div class="m-1">訂單狀態，後</div>
                      <div class="m-1">
                        <b-form-input
                          type="number"
                          :value="orderStatusCondition.days"
                          :disabled="!conditionsCheckboxType.includes('order_status_filter')"
                          min="0"
                          step="1"
                          size="sm"
                          style="width: 100px"
                          @keydown="preventInvalidNumberKey($event, 0)"
                          @input="onPositiveIntInput($event, 'orderStatusCondition.days', 0)"
                        />
                      </div>
                      <div class="m-1">天</div>
                    </div>
                    <div v-if="conditionsCheckboxType.includes('order_status_filter')" class="mt-2 ml-4">
                      <div class="mb-3">
                        <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                        <editor
                          v-model="orderStatusIncludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                      <div>
                        <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                        <editor
                          v-model="orderStatusExcludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                    </div>
                    </b-form-group>

                    <!-- 物流狀態 -->
                    <b-form-group class="mb-3 ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="conditionsCheckboxType_delivery_status"
                        class="form-check-input"
                        value="delivery_status_filter"
                        v-model="conditionsCheckboxType">
                      <div class="m-1">物流狀態，後</div>
                      <div class="m-1">
                        <b-form-input
                          type="number"
                          :value="deliveryStatusCondition.days"
                          :disabled="!conditionsCheckboxType.includes('delivery_status_filter')"
                          min="0"
                          step="1"
                          size="sm"
                          style="width: 100px"
                          @keydown="preventInvalidNumberKey($event, 0)"
                          @input="onPositiveIntInput($event, 'deliveryStatusCondition.days', 0)"
                        />
                      </div>
                      <div class="m-1">天</div>
                    </div>
                    <div v-if="conditionsCheckboxType.includes('delivery_status_filter')" class="mt-2 ml-4">
                      <div class="mb-3">
                        <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                        <editor
                          v-model="deliveryStatusIncludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                      <div>
                        <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                        <editor
                          v-model="deliveryStatusExcludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                    </div>
                    </b-form-group>

                    <!-- 退貨狀態 -->
                    <b-form-group class="mb-3 ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="conditionsCheckboxType_return_status"
                        class="form-check-input"
                        value="return_status_filter"
                        v-model="conditionsCheckboxType">
                      <div class="m-1">退貨狀態，後</div>
                      <div class="m-1">
                        <b-form-input
                          type="number"
                          :value="returnStatusCondition.days"
                          :disabled="!conditionsCheckboxType.includes('return_status_filter')"
                          min="0"
                          step="1"
                          size="sm"
                          style="width: 100px"
                          @keydown="preventInvalidNumberKey($event, 0)"
                          @input="onPositiveIntInput($event, 'returnStatusCondition.days', 0)"
                        />
                      </div>
                      <div class="m-1">天</div>
                    </div>
                    <div v-if="conditionsCheckboxType.includes('return_status_filter')" class="mt-2 ml-4">
                      <div class="mb-3">
                        <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                        <editor
                          v-model="returnStatusIncludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                      <div>
                        <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                        <editor
                          v-model="returnStatusExcludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                    </div>
                    </b-form-group>

                    <!-- 付款狀態 -->
                    <b-form-group class="mb-3 ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="conditionsCheckboxType_payment_status"
                        class="form-check-input"
                        value="payment_status_filter"
                        v-model="conditionsCheckboxType">
                      <div class="m-1">付款狀態，後</div>
                      <div class="m-1">
                        <b-form-input
                          type="number"
                          :value="paymentStatusCondition.days"
                          :disabled="!conditionsCheckboxType.includes('payment_status_filter')"
                          min="0"
                          step="1"
                          size="sm"
                          style="width: 100px"
                          @keydown="preventInvalidNumberKey($event, 0)"
                          @input="onPositiveIntInput($event, 'paymentStatusCondition.days', 0)"
                        />
                      </div>
                      <div class="m-1">天</div>
                    </div>
                    <div v-if="conditionsCheckboxType.includes('payment_status_filter')" class="mt-2 ml-4">
                      <div class="mb-3">
                        <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                        <editor
                          v-model="paymentStatusIncludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                      <div>
                        <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                        <editor
                          v-model="paymentStatusExcludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                    </div>
                    </b-form-group>

                    <!-- 分店名單 -->
                    <b-form-group class="mb-0 ml-4">
                    <div class="d-flex align-items-center">
                      <input
                        type="checkbox"
                        id="conditionsCheckboxType_branch_list"
                        class="form-check-input"
                        value="branch_list_filter"
                        v-model="conditionsCheckboxType">
                      <div class="m-1">允許/排除 分店名單</div>
                    </div>
                    <div v-if="conditionsCheckboxType.includes('branch_list_filter')" class="mt-2 ml-4">
                      <div class="mb-3">
                        <div class="small text-primary mb-1">允許分店 (白名單)</div>
                        <editor
                          v-model="branchListIncludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                      <div>
                        <div class="small text-danger mb-1">排除分店 (黑名單)</div>
                        <editor
                          v-model="branchListExcludeJson"
                          width="100%"
                          height="100px"
                          @init="editorInit"
                          lang="json"
                          theme="chrome"
                          class="border rounded shadow-sm"
                        />
                      </div>
                    </div>
                  </b-form-group>
                  </div>
                </div>
              </div>

              <!-- 點數計算 -->
              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                  <span class="font-weight-bold">點數計算</span>
                </div>
                <div class="card-body">
              <div class="form-check">
                <!-- 無區分會員等級 START -->
                <b-form-group class="d-flex">
                  <input
                    type="radio"
                    id="strategy_by_price_only"
                    class="form-check-input"
                    value="by_price_only"
                    v-model="module.module_config.strategy">
                  <label for="strategy_by_price_only">無區分會員等級</label>
                </b-form-group>

                <div class="d-flex align-items-center py-2 mt-3 mb-3">
                  <b-form-group class="mb-0 flex-grow-1 d-inline-flex align-items-center">
                    訂單滿
                    <b-form-input
                      :disabled="module.module_config.strategy !== 'by_price_only'"
                      class="w-auto mx-2"
                      type="number"
                      :value="module.module_config.by_price_only_params.convertion_price_threshold"
                      min="0"
                      step="1"
                      size="sm"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, 'module.module_config.by_price_only_params.convertion_price_threshold', 0)"
                    />
                    元，
                    給
                    <b-form-input
                      :disabled="module.module_config.strategy !== 'by_price_only'"
                      class="w-auto mx-2"
                      type="number"
                      :value="module.module_config.by_price_only_params.points_per_threshold"
                      min="0"
                      step="1"
                      size="sm"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, 'module.module_config.by_price_only_params.points_per_threshold', 0)"
                    />
                    點
                    <b-form-radio-group
                      :disabled="module.module_config.strategy !== 'by_price_only'"
                      class="d-inline-flex ml-2"
                      v-model="module.module_config.by_price_only_params.allow_multiple_convertion"
                      :options="allowMultipleConvertionOptions"
                    ></b-form-radio-group>
                  </b-form-group>
                </div>
                <!-- 無區分會員等級 END -->

                <!-- 依會員等級 START -->
                <b-form-group class="d-flex">
                  <input
                    type="radio"
                    id="strategy_by_customer_level"
                    class="form-check-input"
                    value="by_customer_level"
                    v-model="module.module_config.strategy">
                  <label for="strategy_by_customer_level">依會員等級</label>
                </b-form-group>
                <div class="mt-3 mb-3 customer-level-grid" v-if="module.module_config.by_customer_level_params.levels.length > 0">
                  <div
                    v-for="(level, index) in module.module_config.by_customer_level_params.levels"
                    :key="index"
                    class="customer-level-item"
                  >
                    <div class="text-right mr-2">
                      {{ levelNameMap[level.customer_level_code] }}
                    </div>

                    訂單滿
                    <b-form-input
                      :disabled="module.module_config.strategy !== 'by_customer_level'"
                        class="w-auto"
                      type="number"
                      :value="level.convertion_price_threshold"
                      min="0"
                      step="1"
                      size="sm"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, `module.module_config.by_customer_level_params.levels[${index}].convertion_price_threshold`, 0)"
                    />
                      元，
                      給
                    <b-form-input
                      :disabled="module.module_config.strategy !== 'by_customer_level'"
                        class="w-auto"
                      type="number"
                      :value="level.points_per_threshold"
                      min="0"
                      step="1"
                      size="sm"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, `module.module_config.by_customer_level_params.levels[${index}].points_per_threshold`, 0)"
                    />
                      點
                    <b-form-radio-group
                      :disabled="module.module_config.strategy !== 'by_customer_level'"
                        class="d-inline-flex ml-2"
                      v-model="level.allow_multiple_convertion"
                      :options="allowMultipleConvertionOptions"
                    ></b-form-radio-group>
                  </div>
                </div>
                <!-- 依會員等級 END -->
              </div>
                </div>
              </div>

              <!-- 點數過期時間 -->
              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                  <span class="font-weight-bold">點數過期時間</span>
                </div>
                <div class="card-body">
              <b-form-group
                label-cols="auto"
                label-size="sm"
                label="日期推算基準"
              >
                <b-form-select
                  v-model="module.module_config.expiration.start_date_condition"
                  :options="expirationStartDateConditionOptions"
                  size="sm"
                  class="w-auto"
                  style="min-width: 150px"
                ></b-form-select>
              </b-form-group>

              <div class="form-check">
                <b-form-group class="align-items-center">
                  <label class="d-flex align-items-center">
                    <input
                      type="radio"
                      class="form-check-input"
                      value="shifted_date"
                      v-model="module.module_config.expiration.type"
                    >
                    依相對時間
                  </label>

                  <div class="d-flex align-items-center">
                    <div class="m-1">
                      <b-form-input
                        type="number"
                        :value="module.module_config.expiration.number"
                        class="w-auto"
                        size="sm"
                        min="1"
                        step="1"
                        @keydown="preventInvalidNumberKey($event, 1)"
                        @input="onPositiveIntInput($event, 'module.module_config.expiration.number', 1)"
                      />
                    </div>
                    <div class="m-1">
                      <b-form-select
                        v-model="module.module_config.expiration.unit"
                        :options="expirationUnitOptions"
                        size="sm"
                        class="w-100"
                        style="min-width: 150px"
                      ></b-form-select>
                    </div>
                  </div>
                </b-form-group>
              </div>

              <div class="form-check">
                <b-form-group class="align-items-center">
                  <label class="d-flex align-items-center">
                    <input
                      type="radio"
                      class="form-check-input"
                      value="fixed_date"
                      v-model="module.module_config.expiration.type"
                    >
                    依特定日期
                    <i
                      class="fa fa-question-circle ml-1 text-muted"
                      style="cursor: pointer;"
                      title="點擊，觀看設定說明"
                      @click.stop="showFixedDateModal = true"
                    ></i>
                  </label>

                  <div class="d-flex align-items-center mb-2">
                    年度起始日：
                    <b-form-select
                      v-model="module.module_config.expiration.period_start_month"
                      :options="monthOptions"
                      size="sm"
                      class="w-auto mx-2"
                      style="min-width: 150px"
                    ></b-form-select>
                    月
                    <b-form-select
                      v-model="module.module_config.expiration.period_start_day"
                      :options="dayOptions(module.module_config.expiration.period_start_month)"
                      size="sm"
                      class="w-auto mx-2"
                      style="min-width: 150px"
                    ></b-form-select>
                    日
                  </div>

                  <div class="d-flex align-items-center mb-2">
                    年度終止日：
                    <b-form-select
                      v-model="module.module_config.expiration.period_end_month"
                      :options="monthOptions"
                      size="sm"
                      class="w-auto mx-2"
                      style="min-width: 150px"
                      disabled
                    ></b-form-select>
                    月
                    <b-form-select
                      v-model="module.module_config.expiration.period_end_day"
                      :options="dayOptions(module.module_config.expiration.period_end_month)"
                      size="sm"
                      class="w-auto mx-2"
                      style="min-width: 150px"
                      disabled
                    ></b-form-select>
                    日
                  </div>

                  <div class="d-flex align-items-center mb-2">
                    過期日：年度終止日
                    <b-form-input
                      v-model.number="module.module_config.expiration.expiry_offset_years"
                      type="number"
                      class="w-auto mx-2"
                      size="sm"
                      min="1"
                      step="1"
                    />
                    年後的
                    <b-form-select
                      v-model="module.module_config.expiration.expiry_month"
                      :options="expiryMonthOptions"
                      size="sm"
                      class="w-auto mx-2"
                      style="min-width: 150px"
                    ></b-form-select>
                    月
                    <b-form-select
                      v-model="module.module_config.expiration.expiry_day"
                      :options="expiryDayOptions"
                      size="sm"
                      class="w-auto mx-2"
                      style="min-width: 150px"
                    ></b-form-select>
                    日
                  </div>

                  <div
                    v-if="module.module_config.expiration.type === 'fixed_date' && fixedDatePreview"
                    class="mt-2"
                  >
                    <div
                      class="d-flex align-items-center"
                      style="cursor: pointer; font-size: 0.875rem; color: #28a745;"
                      @click="showFixedDatePreview = !showFixedDatePreview"
                    >
                      <i :class="showFixedDatePreview ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" class="mr-1"></i>
                      預覽試算
                    </div>
                    <div
                      v-if="showFixedDatePreview"
                      class="mt-1 p-2 rounded border border-success"
                      style="font-size: 0.875rem; color: #28a745; background-color: #f0fff4;"
                    >
                      若您在 今日: <strong>{{ fixedDatePreview.todayStr }}</strong> 發放點數，<br>
                      該點數將歸屬於 <strong>{{ fixedDatePreview.cycleStartStr }} ~ {{ fixedDatePreview.cycleEndStr }}</strong> 週期，並於 <strong>{{ fixedDatePreview.expiryStr }}</strong> 到期。
                    </div>
                  </div>
                </b-form-group>
              </div>

              <b-modal
                v-model="showFixedDateModal"
                title="點數(依特定日期) 說明"
                ok-only
                ok-title="關閉"
                dialog-class="modal-half"
              >
                <p>系統將依據您設定的「年度週期」歸納點數，同一週期內獲得的點數，將統一於指定的延長年份日期失效。</p>
                <p><strong>舉例情境：</strong>若設定週期為 1/10 至 隔年1/9，並於 1 年後的 12/31 失效。若會員在 2026/01/30 獲得點數（屬於2026/01/10 ~ 2027/01/09 週期），該筆點數將於 2028/12/31 正式失效。</p>
              </b-modal>

              <div class="form-check">
                <b-form-group class="align-items-center">
                  <label class="d-flex align-items-center">
                    <input
                      type="radio"
                      class="form-check-input"
                      value="none"
                      v-model="module.module_config.expiration.type"
                    >
                    無期限
                  </label>
                </b-form-group>
              </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 訂單入點 END -->

          <!-- 訂單扣點 START -->
          <section class="row mb-5">
            <div class="col-12 col-xl-10">
              <h4 class="mb-4 text-primary">
                訂單扣點
                <i
                  class="fa fa-question-circle ml-2 text-muted"
                  id="order-deduct-tooltip"
                  style="font-size: 1rem;"
                ></i>
                <b-tooltip target="order-deduct-tooltip" triggers="hover" placement="right">
                  因訂單成立，用戶使用點數折抵
                </b-tooltip>
              </h4>

              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                  <span class="font-weight-bold">訂單條件</span>
                </div>
                <div class="card-body">
              <div>
                <b-form-group
                  label-cols="auto"
                  label-size="sm"
                >
                  <!-- 自訂 label -->
                  <template #label>
                   <span class="d-inline-flex align-items-center mr-3">
                      下單後扣除已使用點數
                      <i
                        class="fa fa-question-circle ml-2"
                        id="deduct-point-tooltip"
                      ></i>
                    </span>
                  </template>

                  <div class="d-flex align-items-center h-100">
                    <b-form-checkbox
                      v-model="module.module_config.allow_deduct_reward_points_used"
                    ></b-form-checkbox>
                  </div>

                  <!-- Tooltip -->
                  <b-tooltip
                    target="deduct-point-tooltip"
                    triggers="hover"
                    placement="right"
                  >
                    訂單若有使用點數，將自動從可用點數中扣除
                  </b-tooltip>
                </b-form-group>
              </div>

              <hr class="my-4">

              <div>
                <div class="d-flex align-items-center mb-3">
                  <h6 class="font-weight-bold mb-0">時間範圍</h6>
                </div>

                <b-form-group class="ml-4">
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      value="deducting_calculation_start_date"
                      v-model="conditionsCheckboxType"
                    >
                    <div class="m-1">
                      <b-form-select
                        v-model="module.module_config.calculation_start_date.deducting.by"
                        :options="calculationStartDateByOptions"
                        :disabled="!conditionsCheckboxType.includes('deducting_calculation_start_date')"
                        size="sm"
                        class="w-auto"
                        style="min-width: 120px"
                      ></b-form-select>
                    </div>
                    <div class="m-1">應晚於：</div>
                    <div class="m-1 d-flex">
                      <AppDatePicker
                        size="sm"
                        v-model="module.module_config.calculation_start_date.deducting.date"
                        :disabled="!conditionsCheckboxType.includes('deducting_calculation_start_date')"
                      />
                    </div>
                  </div>
                </b-form-group>
              </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 訂單扣點 END -->

          <!-- 訂單退貨 START -->
          <section class="row mb-5">
            <div class="col-12 col-xl-10">
              <h4 class="mb-4 text-primary">
                訂單退貨
                <i
                  class="fa fa-question-circle ml-2 text-muted"
                  id="order-refund-tooltip"
                  style="font-size: 1rem;"
                ></i>
                <b-tooltip target="order-refund-tooltip" triggers="hover" placement="right">
                  因訂單取消或退貨，系統回收已發放之點數
                </b-tooltip>
              </h4>

              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                  <span class="font-weight-bold">訂單條件</span>
                </div>
                <div class="card-body">
              <div class="mb-4">
                <!-- 處理金額非負數的訂單 -->
                <b-form-group
                  label-cols="auto"
                  label-size="sm"
                  class="mb-0"
                >
                  <template #label>
                    <span class="d-inline-flex align-items-center mr-3">退單扣點之適用金額<i
                        class="fa fa-question-circle ml-2"
                        id="allow-revoke-positive-amount-orders-tooltip"
                      ></i></span>
                  </template>

                  <div class="d-flex align-items-center h-100">
                    <b-form-select
                      v-model="allowRevokePositiveAmountOrders"
                      :options="allowRevokePositiveAmountOrdersOptions"
                      size="sm"
                      class="w-auto"
                      style="min-width: 150px"
                    ></b-form-select>
                  </div>

                  <b-tooltip
                    target="allow-revoke-positive-amount-orders-tooltip"
                    triggers="hover"
                    placement="right"
                  >
                    設定退貨扣點機制適用的訂單金額類型
                  </b-tooltip>
                </b-form-group>
              </div>

              <hr class="my-4">

              <div>
                <div class="d-flex align-items-center mb-3">
                  <h6 class="font-weight-bold mb-0">時間範圍</h6>
                </div>

                <b-form-group class="ml-4">
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      value="returning_calculation_start_date"
                      v-model="conditionsCheckboxType"
                    >
                    <div class="m-1">
                      <b-form-select
                        v-model="module.module_config.calculation_start_date.returning.by"
                        :options="calculationStartDateByOptions"
                        :disabled="!conditionsCheckboxType.includes('returning_calculation_start_date')"
                        size="sm"
                        class="w-auto"
                        style="min-width: 120px"
                      ></b-form-select>
                    </div>
                    <div class="m-1">應晚於：</div>
                    <div class="m-1 d-flex">
                      <AppDatePicker
                        size="sm"
                        v-model="module.module_config.calculation_start_date.returning.date"
                        :disabled="!conditionsCheckboxType.includes('returning_calculation_start_date')"
                      />
                    </div>
                  </div>
                </b-form-group>
              </div>

              <hr class="my-4">

              <div>
                <div class="d-flex align-items-center mb-3">
                  <h6 class="font-weight-bold mb-0">進階篩選</h6>
                  <small class="text-muted ml-2">設定特定訂單狀態或分店</small>
                </div>

                <!-- 訂單狀態 -->
                <b-form-group class="mb-3 ml-4">
                <div class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="conditionsCheckboxType_revoke_status"
                    class="form-check-input"
                    value="revoke_status_filter"
                    v-model="conditionsCheckboxType">
                  <div class="m-1">訂單狀態，後</div>
                  <div class="m-1">
                    <b-form-input
                      type="number"
                      :value="revokeStatusCondition.days"
                      :disabled="!conditionsCheckboxType.includes('revoke_status_filter')"
                      min="0"
                      step="1"
                      size="sm"
                      style="width: 100px"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, 'revokeStatusCondition.days', 0)"
                    />
                  </div>
                  <div class="m-1">天</div>
                </div>
                <div v-if="conditionsCheckboxType.includes('revoke_status_filter')" class="mt-2 ml-4">
                  <div class="mb-3">
                    <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                    <editor
                      v-model="revokeStatusIncludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                  <div>
                    <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                    <editor
                      v-model="revokeStatusExcludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                </div>
                </b-form-group>

                <!-- 物流狀態 -->
                <b-form-group class="mb-3 ml-4">
                <div class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="conditionsCheckboxType_revoke_delivery_status"
                    class="form-check-input"
                    value="revoke_delivery_status_filter"
                    v-model="conditionsCheckboxType">
                  <div class="m-1">物流狀態，後</div>
                  <div class="m-1">
                    <b-form-input
                      type="number"
                      :value="revokeDeliveryStatusCondition.days"
                      :disabled="!conditionsCheckboxType.includes('revoke_delivery_status_filter')"
                      min="0"
                      step="1"
                      size="sm"
                      style="width: 100px"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, 'revokeDeliveryStatusCondition.days', 0)"
                    />
                  </div>
                  <div class="m-1">天</div>
                </div>
                <div v-if="conditionsCheckboxType.includes('revoke_delivery_status_filter')" class="mt-2 ml-4">
                  <div class="mb-3">
                    <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                    <editor
                      v-model="revokeDeliveryStatusIncludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                  <div>
                    <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                    <editor
                      v-model="revokeDeliveryStatusExcludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                </div>
                </b-form-group>

                <!-- 退貨狀態 -->
                <b-form-group class="mb-3 ml-4">
                <div class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="conditionsCheckboxType_revoke_return_status"
                    class="form-check-input"
                    value="revoke_return_status_filter"
                    v-model="conditionsCheckboxType">
                  <div class="m-1">退貨狀態，後</div>
                  <div class="m-1">
                    <b-form-input
                      type="number"
                      :value="revokeReturnStatusCondition.days"
                      :disabled="!conditionsCheckboxType.includes('revoke_return_status_filter')"
                      min="0"
                      step="1"
                      size="sm"
                      style="width: 100px"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, 'revokeReturnStatusCondition.days', 0)"
                    />
                  </div>
                  <div class="m-1">天</div>
                </div>
                <div v-if="conditionsCheckboxType.includes('revoke_return_status_filter')" class="mt-2 ml-4">
                  <div class="mb-3">
                    <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                    <editor
                      v-model="revokeReturnStatusIncludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                  <div>
                    <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                    <editor
                      v-model="revokeReturnStatusExcludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                </div>
                </b-form-group>

                <!-- 付款狀態 -->
                <b-form-group class="mb-3 ml-4">
                <div class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="conditionsCheckboxType_revoke_payment_status"
                    class="form-check-input"
                    value="revoke_payment_status_filter"
                    v-model="conditionsCheckboxType">
                  <div class="m-1">付款狀態，後</div>
                  <div class="m-1">
                    <b-form-input
                      type="number"
                      :value="revokePaymentStatusCondition.days"
                      :disabled="!conditionsCheckboxType.includes('revoke_payment_status_filter')"
                      min="0"
                      step="1"
                      size="sm"
                      style="width: 100px"
                      @keydown="preventInvalidNumberKey($event, 0)"
                      @input="onPositiveIntInput($event, 'revokePaymentStatusCondition.days', 0)"
                    />
                  </div>
                  <div class="m-1">天</div>
                </div>
                <div v-if="conditionsCheckboxType.includes('revoke_payment_status_filter')" class="mt-2 ml-4">
                  <div class="mb-3">
                    <div class="small text-primary mb-1">允許狀態 (白名單)</div>
                    <editor
                      v-model="revokePaymentStatusIncludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                  <div>
                    <div class="small text-danger mb-1">排除當下狀態 (黑名單)</div>
                    <editor
                      v-model="revokePaymentStatusExcludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                </div>
                </b-form-group>

                <!-- 分店名單 -->
                <b-form-group class="mb-0 ml-4">
                <div class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    id="conditionsCheckboxType_revoke_branch_list"
                    class="form-check-input"
                    value="revoke_branch_list_filter"
                    v-model="conditionsCheckboxType">
                  <div class="m-1">允許/排除 分店名單</div>
                </div>
                <div v-if="conditionsCheckboxType.includes('revoke_branch_list_filter')" class="mt-2 ml-4">
                  <div class="mb-3">
                    <div class="small text-primary mb-1">允許分店 (白名單)</div>
                    <editor
                      v-model="revokeBranchListIncludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                  <div>
                    <div class="small text-danger mb-1">排除分店 (黑名單)</div>
                    <editor
                      v-model="revokeBranchListExcludeJson"
                      width="100%"
                      height="100px"
                      @init="editorInit"
                      lang="json"
                      theme="chrome"
                      class="border rounded shadow-sm"
                    />
                  </div>
                </div>
              </b-form-group>
              </div>
                </div>
              </div>

              <!-- 點數處理 START -->
              <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center py-2">
                  <span class="font-weight-bold">點數處理</span>
                </div>
                <div class="card-body">
                  <b-form-group
                    label-cols="auto"
                    label-size="sm"
                  >
                    <!-- 自訂 label -->
                    <template #label>
                     <span class="d-inline-flex align-items-center mr-3">
                        退貨後回收點數
                        <i
                          class="fa fa-question-circle ml-2"
                          id="refund-point-tooltip"
                        ></i>
                      </span>
                    </template>

                    <div class="d-flex align-items-center h-100">
                      <b-form-checkbox
                        v-model="module.module_config.allow_revoke_reward_points"
                      ></b-form-checkbox>
                    </div>

                    <!-- Tooltip -->
                    <b-tooltip
                      target="refund-point-tooltip"
                      triggers="hover"
                      placement="right"
                    >
                      退貨時自動收回已發放點數
                    </b-tooltip>
                  </b-form-group>

                  <b-form-group
                    label-cols="auto"
                    label-size="sm"
                    label="尚未發放點數的正數訂單"
                  >
                    <div class="d-flex align-items-center h-100">
                      <b-form-radio-group
                        class="d-inline-flex ml-2"
                        v-model="module.module_config.should_revoke_ungained_points_for_positive_orders"
                        :options="revokeUngainedPointsOptions"
                      ></b-form-radio-group>
                    </div>
                  </b-form-group>

                  <b-form-group
                    label-cols="auto"
                    label-size="sm"
                    label="尚未發放點數的負數訂單"
                  >
                    <div class="d-flex align-items-center h-100">
                      <b-form-radio-group
                        class="d-inline-flex ml-2"
                        v-model="module.module_config.should_revoke_ungained_points_for_negative_orders"
                        :options="revokeUngainedPointsOptions"
                      ></b-form-radio-group>
                    </div>
                  </b-form-group>

                  <b-form-group
                    label-cols="auto"
                    label-size="sm"
                    class="mb-0"
                  >
                    <!-- 自訂 label -->
                    <template #label>
                     <span class="d-inline-flex align-items-center mr-3">
                        整張訂單退貨後，返還點數
                        <i
                          class="fa fa-question-circle ml-2"
                          id="return-reward-points-used-tooltip"
                        ></i>
                      </span>
                    </template>

                    <div class="d-flex align-items-center h-100">
                      <b-form-checkbox
                        v-model="module.module_config.allow_return_reward_points_used"
                      ></b-form-checkbox>
                    </div>

                    <!-- Tooltip -->
                    <b-tooltip
                      target="return-reward-points-used-tooltip"
                      triggers="hover"
                      placement="right"
                    >
                      整張訂單退貨後，返還給會員於該訂單所使用之點數
                    </b-tooltip>
                  </b-form-group>
                </div>
              </div>
            </div>
          </section>
          <!-- 訂單退貨 END -->
        </b-overlay>

      </b-overlay>

      <div class="mt-4 d-flex justify-content-center">
        <b-button
          class="mr-4"
          variant="outline-danger"
          @click="goToList"
        >
          返回
        </b-button>
        <b-overlay
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button variant="success" @click="submit" :disabled="!isFormEnabled">
            送出
          </b-button>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import { get as deepGet, set as deepSet } from "lodash";
import { mapState, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import customerLevelApi from "@/apis/customer-levels";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import moduleApi from "@/apis/module";
import store from "@/store";
import merchantApi from "@/apis/merchant";
import { required } from "@vuelidate/validators";
import mergeDefaultAndDataSource from "@/utils/mergeDefaultAndDataModel";
import editor from "vue2-ace-editor";
import orgNameMixin from "@/mixins/organizationName";
import imageMixin from "@/mixins/uploadImage";
import AppDatePicker from "@/components/AppDatePicker.vue";

const DEFAULT_MODULE_CONFIG = {
  strategy: "by_price_only",
  conditions: [],
  to_merchant_type: "",
  calculation_start_date: {
    gaining: {
      by: "order_at",
      date: null
    },
    deducting: {
      by: "order_at",
      date: null
    },
    returning: {
      by: "order_at",
      date: null
    }
  },
  expiration: {
    /* shifted_date: 依相對時間, fixed_date: 依特定日期, none: 無期限 */
    type: "shifted_date",
    /* 依相對時間 */
    unit: "day",
    number: 1,
    start_date_condition: "ordered",
    /* 依特定日期 */
    period_start_month: 1,
    period_start_day: 1,
    period_end_month: 12,
    period_end_day: 31,
    expiry_offset_years: 1,
    expiry_month: 12,
    expiry_day: 31
  },
  price_column: "total",
  by_price_only_params: {
    allow_multiple_convertion: false,
    points_per_threshold: null,
    convertion_price_threshold: null,
  },
  by_customer_level_params: {
    levels: [],
  },
  allow_revoke_reward_points: false,
  allow_deduct_reward_points_used: false,
  allow_return_reward_points_used: false,
  should_revoke_ungained_points_for_positive_orders: true,
  should_revoke_ungained_points_for_negative_orders: true,
};

const START_TIME_CONDITION_TEMPLATE = {
  days: 180,
  type: "created_n_days",
}

const END_TIME_CONDITION_TEMPLATE = {
  days: 180,
  type: "before_created_n_days",
}

const LEVELS_TEMPLATE = {
  customer_level_code: "",
  allow_multiple_convertion: false,
  points_per_threshold: null,
  convertion_price_threshold: null
}

export default {
  mixins: [orgNameMixin, imageMixin],
  components: { editor, AppDatePicker },
  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      module: {
        module_code: { required },
      },
    };
  },

  data() {
    return {
      isSubmmiting: false,
      isFetchingMerchants: false,
      isFetchingModule: false,
      isFetchingCustomerLevels: false,
      isFormEnabled: false,

      rawMerchants: [],
      modulesOfCurrentOrg: [],
      customerLevels: [],

      moduleId: null,
      module: {
        module_code: "order-to-point",
        module_config: { ...DEFAULT_MODULE_CONFIG },
        merchant_id: null,
        is_enabled: 0,
        name: "訂單點數設定",
      },

      conditionsCheckboxType: [],
      startTimeCondition: {
        days: 180,
        type: "created_n_days",
      },
      endTimeCondition: {
        days: 180,
        type: "before_created_n_days",
      },
      orderStatusCondition: {
        days: 1,
      },
      deliveryStatusCondition: {
        days: 1,
      },
      returnStatusCondition: {
        days: 1,
      },
      paymentStatusCondition: {
        days: 1,
      },
      orderStatusIncludeJson: '',
      orderStatusExcludeJson: '',
      deliveryStatusIncludeJson: '',
      deliveryStatusExcludeJson: '',
      returnStatusIncludeJson: '',
      returnStatusExcludeJson: '',
      paymentStatusIncludeJson: '',
      paymentStatusExcludeJson: '',
      branchListIncludeJson: '',
      branchListExcludeJson: '',
      revokeStatusCondition: {
        days: 1,
      },
      revokeDeliveryStatusCondition: {
        days: 1,
      },
      revokeReturnStatusCondition: {
        days: 1,
      },
      revokePaymentStatusCondition: {
        days: 1,
      },
      allowRevokePositiveAmountOrders: false,
      allowRevokePositiveAmountOrdersOptions: [
        { value: false, text: '只處理負數的訂單' },
        { value: true, text: '正數與負數訂單皆處理' },
      ],
      revokeStatusIncludeJson: '',
      revokeStatusExcludeJson: '',
      revokeDeliveryStatusIncludeJson: '',
      revokeDeliveryStatusExcludeJson: '',
      revokeReturnStatusIncludeJson: '',
      revokeReturnStatusExcludeJson: '',
      revokePaymentStatusIncludeJson: '',
      revokePaymentStatusExcludeJson: '',
      revokeBranchListIncludeJson: '',
      revokeBranchListExcludeJson: '',

      showFixedDateModal: false,
      showFixedDatePreview: false,

      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [this.MyCustomUploadAdapterPlugin],
      },
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters("route", ["routeQuery"]),
    orgId() {
      return store.state.general.organization.id
    },
    isEdit() {
      return this.moduleId !== null
    },
    isLoading() {
      return this.isFetchingMerchants || this.isFetchingModule || this.isFetchingCustomerLevels;
    },
    levelNameMap() {
      const map = {}
      this.customerLevels.forEach(level => {
        map[level.code] = level.name
      })
      return map
    },
    isTimeRangeInvalid() {
      const hasStartTime = this.conditionsCheckboxType.includes('start_time_query')
      const hasEndTime = this.conditionsCheckboxType.includes('end_time_query')

      if (!hasStartTime || !hasEndTime) {
        return false
      }

      return this.startTimeCondition.days > this.endTimeCondition.days
    },
    monthOptions() {
      return Array.from({ length: 12 }, (_, i) => ({ value: i + 1, text: i + 1 }));
    },
    computedPeriodEnd(){
      const startMonth = this.module.module_config.expiration.period_start_month;
      const startDay = this.module.module_config.expiration.period_start_day;

      if (!startMonth || !startDay) return { month: null, day: null };

      const currentYear = new Date().getFullYear();
      const date = new Date(currentYear, startMonth - 1, startDay);
      date.setDate(date.getDate() - 1);

      return {
        month: date.getMonth() + 1,
        day: date.getDate()
      };
    },
    expiryMonthOptions() {
      const offsetYears = this.module.module_config.expiration.expiry_offset_years;

      if (offsetYears !== 0) {
        return this.monthOptions;
      }

      const periodEndMonth = this.module.module_config.expiration.period_end_month;
      return this.monthOptions.filter(option => option.value >= periodEndMonth);
    },
    expiryDayOptions() {
      const month = this.module.module_config.expiration.expiry_month;
      const offsetYears = this.module.module_config.expiration.expiry_offset_years;

      if (!month) return [];

      const currentYear = new Date().getFullYear();
      const targetYear = currentYear + Number(offsetYears);
      const daysInMonth = new Date(targetYear, month, 0).getDate();
      const days = Array.from({ length: daysInMonth }, (_, i) => ({ value: i + 1, text: i + 1 }));

      // 當年度的過期日需晚於年度終止日
      if (offsetYears === 0) {
        const periodEndMonth = this.module.module_config.expiration.period_end_month;
        const periodEndDay = this.module.module_config.expiration.period_end_day;
        const expiryMonth = this.module.module_config.expiration.expiry_month;

        if (expiryMonth === periodEndMonth) {
          return days.filter(day => day.value >= periodEndDay);
        }
      }

      return days;
    },
    strategyOptions: () => [
      { value: "by_customer_level", text: "依會員等級" },
      { value: "by_price_only", text: "不分會員等級" },
    ],
    endTimeQueryConditionOptions: () => [
      { value: "before_created_n_days", text: "下單後(order_at)" },
      { value: "before_completed_n_days", text: "訂單完成後(completed_at)" },
    ],
    startTimeQueryConditionOptions: () => [
      { value: "created_n_days", text: "下單後(order_at)" },
      { value: "completed_n_days", text: "訂單完成後(completed_at)" },
    ],
    calculationStartDateByOptions: () => [
      { value: "order_at", text: "下單日期(order_at)" },
      { value: "completed_at", text: "訂單完成日期(completed_at)" },
    ],
    expirationStartDateConditionOptions: () => [
      { value: "ordered", text: "下單後(order_at)" },
      { value: "completed", text: "訂單完成後(completed_at)" },
      { value: "calculated", text: "給點後" },
    ],
    expirationUnitOptions: () => [
      { value: "day", text: "天" },
      { value: "month", text: "月" },
      { value: "year", text: "年" },
    ],
    revokeUngainedPointsOptions: () => [
      { value: true, text: "需回收點數" },
      { value: false, text: "不需回收點數" },
    ],
    fixedDatePreview() {
      const exp = this.module.module_config.expiration;
      const { period_start_month, period_start_day, period_end_month, period_end_day, expiry_offset_years, expiry_month, expiry_day } = exp;
      if (!period_start_month || !period_start_day || !period_end_month || !period_end_day || !expiry_month || !expiry_day) {
        return null;
      }
      const today = new Date();
      const periodStartThisYear = new Date(today.getFullYear(), period_start_month - 1, period_start_day);
      const cycleStartYear = today >= periodStartThisYear ? today.getFullYear() : today.getFullYear() - 1;
      const crossesYear = period_start_month > period_end_month ||
        (period_start_month === period_end_month && period_start_day > period_end_day);
      const cycleEndYear = crossesYear ? cycleStartYear + 1 : cycleStartYear;
      const expiryYear = cycleEndYear + Number(expiry_offset_years);
      const fmt = (y, m, d) => `${y}/${String(m).padStart(2, '0')}/${String(d).padStart(2, '0')}`;
      return {
        todayStr: fmt(today.getFullYear(), today.getMonth() + 1, today.getDate()),
        cycleStartStr: fmt(cycleStartYear, period_start_month, period_start_day),
        cycleEndStr: fmt(cycleEndYear, period_end_month, period_end_day),
        expiryStr: fmt(expiryYear, expiry_month, expiry_day),
      };
    },
    priceColumnOptions: () => [
      { value: "total", text: "總金額" },
    ],
    allowMultipleConvertionOptions: () => [
      { value: true, text: '可累加' },
      { value: false, text: '不可累加' },
    ],
    merchants() {
      const merchantNullEnabled = this.modulesOfCurrentOrg.some(module => module.is_enabled && module.merchant_id === null);
      const normaMerchantEnabled = this.modulesOfCurrentOrg.some(module => module.is_enabled && module.merchant_id !== null);

      return [
        { value: null, text: "請選擇" },
        { value: 0, text: "【(全通路)品牌組織階層】", disabled: !merchantNullEnabled && normaMerchantEnabled },
        ...this.rawMerchants.map((merchant) => {
          return {
            value: merchant.id,
            text: merchant.type_name
              ? `- ${merchant.name} (${merchant.type_name})`
              : `- ${merchant.name}`,
            disabled: !normaMerchantEnabled && merchantNullEnabled
          };
        }),
      ];
    },
    merchantTypes() {
      return [
        { value: "", text: "依訂單通路入點" },
        ...this.rawMerchants.map((merchant) => {
          return {
            value: merchant.type,
            text: merchant.type
          };
        }),
      ];
    },
  },
  watch: {
    'module.merchant_id'() {
      this.fetchModule()
    },
    'module.module_config.expiration.period_start_month'() {
      this.updatePeriodEnd();
    },
    'module.module_config.expiration.period_start_day'() {
      this.updatePeriodEnd();
    },
    'module.module_config.expiration.expiry_offset_years'() {
      this.validateExpiryDate();
    },
    'module.module_config.expiration.expiry_month'() {
      this.validateExpiryDate();
    },
    'module.module_config.expiration.expiry_day'() {
      this.validateExpiryDate();
    },
    'startTimeCondition.type'(newValue) {
      // 當給點條件都勾選時，截止時間狀態要跟著起始時間變動
      const bothChecked = this.conditionsCheckboxType.includes('start_time_query') &&
                         this.conditionsCheckboxType.includes('end_time_query');

      if (bothChecked) {
        if (newValue === 'created_n_days') {
          this.endTimeCondition.type = 'before_created_n_days';
        } else if (newValue === 'completed_n_days') {
          this.endTimeCondition.type = 'before_completed_n_days';
        }
      }
    },
    conditionsCheckboxType(newVal, oldVal) {
      // Handle calculation_start_date checkboxes
      if (!newVal.includes('gaining_calculation_start_date') && oldVal.includes('gaining_calculation_start_date')) {
        this.module.module_config.calculation_start_date.gaining.date = null;
      }
      if (!newVal.includes('deducting_calculation_start_date') && oldVal.includes('deducting_calculation_start_date')) {
        this.module.module_config.calculation_start_date.deducting.date = null;
      }
      if (!newVal.includes('returning_calculation_start_date') && oldVal.includes('returning_calculation_start_date')) {
        this.module.module_config.calculation_start_date.returning.date = null;
      }

      const filterConfigs = [
        { key: 'order_status_filter', prefix: 'orderStatus', hasDays: true },
        { key: 'delivery_status_filter', prefix: 'deliveryStatus', hasDays: true },
        { key: 'return_status_filter', prefix: 'returnStatus', hasDays: true },
        { key: 'payment_status_filter', prefix: 'paymentStatus', hasDays: true },
        { key: 'branch_list_filter', prefix: 'branchList', hasDays: false },
        { key: 'revoke_status_filter', prefix: 'revokeStatus', hasDays: true },
        { key: 'revoke_delivery_status_filter', prefix: 'revokeDeliveryStatus', hasDays: true },
        { key: 'revoke_return_status_filter', prefix: 'revokeReturnStatus', hasDays: true },
        { key: 'revoke_payment_status_filter', prefix: 'revokePaymentStatus', hasDays: true },
        { key: 'revoke_branch_list_filter', prefix: 'revokeBranchList', hasDays: false },
      ];

      filterConfigs.forEach(({ key, prefix, hasDays }) => {
        const isChecked = newVal.includes(key) && !oldVal.includes(key);
        const isUnchecked = !newVal.includes(key) && oldVal.includes(key);

        if (isChecked) {
          if (!this[`${prefix}IncludeJson`] || this[`${prefix}IncludeJson`].trim() === '') {
            this[`${prefix}IncludeJson`] = '[]';
          }
          if (!this[`${prefix}ExcludeJson`] || this[`${prefix}ExcludeJson`].trim() === '') {
            this[`${prefix}ExcludeJson`] = '[]';
          }
        } else if (isUnchecked) {
          this[`${prefix}IncludeJson`] = '';
          this[`${prefix}ExcludeJson`] = '';
          if (hasDays) {
            this[`${prefix}Condition`].days = 1;
          }
        }
      });
    }
  },
  async mounted() {
    if (!this.checkPermission([consts.MODULE_ORDER_TO_POINTS_MODIFY])) {
      this.$swal
        .fire({
        type: "error",
        text: "你沒有權限訪問此頁面",
        confirmButtonColor: "#d33",
        })
        .then(() => {
          this.goToList();
      });
    }

    await Promise.all([
      this.getCustomerLevelsList(),
      this.getMerchants(),
      this.fetchModulesOfCurrentOrg()
    ])

    this.initForm();

    if (this.$route.query.merchant_id !== undefined) {
      const queryId = this.$route.query.merchant_id;
      this.module.merchant_id = (queryId === 'all') ? 0 : queryId;
    }
  },
  methods: {
    /**
     * 初始化 ace-editor，載入 JSON 語法與主題
     */
    editorInit() {
      require("brace/ext/language_tools");
      require("brace/mode/json");
      require("brace/theme/chrome");
    },
    async initForm() {
      this.module.module_config.by_customer_level_params.levels = this.customerLevels.map(level => ({
        ...LEVELS_TEMPLATE,
        customer_level_code: level.code,
      }));

      this.startTimeCondition = { ...START_TIME_CONDITION_TEMPLATE };
      this.endTimeCondition = { ...END_TIME_CONDITION_TEMPLATE };
      this.conditionsCheckboxType = [];
      this.module.is_enabled = false;
      this.orderStatusCondition = { days: 1 };
      this.deliveryStatusCondition = { days: 1 };
      this.returnStatusCondition = { days: 1 };
      this.paymentStatusCondition = { days: 1 };
      this.orderStatusFilterJson = '';
      this.deliveryStatusFilterJson = '';
      this.returnStatusFilterJson = '';
      this.paymentStatusFilterJson = '';
      this.branchListFilterJson = '';
      this.revokeStatusCondition = { days: 1 };
      this.revokeDeliveryStatusCondition = { days: 1 };
      this.revokeReturnStatusCondition = { days: 1 };
      this.revokePaymentStatusCondition = { days: 1 };
      this.revokeStatusFilterJson = '';
      this.revokeDeliveryStatusFilterJson = '';
      this.revokeReturnStatusFilterJson = '';
      this.revokePaymentStatusFilterJson = '';
      this.revokeBranchListFilterJson = '';
      this.updatePeriodEnd();
    },
    async getCustomerLevelsList() {
      try {
        this.isFetchingCustomerLevels = true;
        this.customerLevels = deepGet(await customerLevelApi.list(), 'data.data') || [];
      } catch (error) {
        console.error(error);
      } finally {
        this.isFetchingCustomerLevels = false;
      }
    },
    async getMerchants() {
      this.isFetchingMerchants = true;
      this.rawMerchants = deepGet(await merchantApi.list(), 'data.data') || [];
      this.isFetchingMerchants = false;
    },
    async fetchModulesOfCurrentOrg() {
      this.isFetchingModule = true;
      const { data } = await moduleApi.getModules(this.orgId, {
        is_enabled: 1,
        keyword: this.module.module_code
      });
      this.isFetchingModule = false;
      this.modulesOfCurrentOrg = data.data || [];
    },
    async fetchModule() {
      if (this.module.merchant_id !== null) {
        const urlId = (this.module.merchant_id == 0) ? 'all' : this.module.merchant_id;
        if (this.$route.query.merchant_id !== urlId) {
          this.$router.push({
            query: { ...this.$route.query, merchant_id: urlId },
          }).catch(() => {});
        }
      } else {
        if (this.$route.query.merchant_id) {
          const query = { ...this.$route.query };
          delete query.merchant_id;
          this.$router.push({ query }).catch(() => {});
        }
      }

      try {
        this.initForm();
        if (this.module.merchant_id === null) {
          this.isFormEnabled = false;
          return;
        }

        this.isFetchingModule = true;
        const { data } = await moduleApi.getModuleByMerchantAndCode(this.orgId, this.module.merchant_id, this.module.module_code);
        this.isFetchingModule = false;

        if (data?.data?.id == null) {
          this.isFormEnabled = false;
          return;
        }
        this.isFormEnabled = true;

        this.moduleId = data.data.id;
        this.module.is_enabled = data.data.is_enabled ? true : false;
        const config = data.data.module_config;

        // 清空 initForm 的 levels，避免 defaultsDeep 合併問題
        //this.module.module_config.by_customer_level_params.levels = [];
        this.module.module_config = mergeDefaultAndDataSource(DEFAULT_MODULE_CONFIG, config);

        // 以 API 回傳的 levels 為主，沒有資料時才用預設值
        const apiLevels = config.by_customer_level_params?.levels;
        this.module.module_config.by_customer_level_params.levels = apiLevels?.length
          ? apiLevels
          : this.customerLevels.map(level => ({ ...LEVELS_TEMPLATE, customer_level_code: level.code }));

        this.conditionsCheckboxType = [];
        this.orderStatusIncludeJson = '';
        this.orderStatusExcludeJson = '';
        this.deliveryStatusIncludeJson = '';
        this.deliveryStatusExcludeJson = '';
        this.returnStatusIncludeJson = '';
        this.returnStatusExcludeJson = '';
        this.paymentStatusIncludeJson = '';
        this.paymentStatusExcludeJson = '';
        this.branchListIncludeJson = '';
        this.branchListExcludeJson = '';
        this.revokeStatusIncludeJson = '';
        this.revokeStatusExcludeJson = '';
        this.revokeDeliveryStatusIncludeJson = '';
        this.revokeDeliveryStatusExcludeJson = '';
        this.revokeReturnStatusIncludeJson = '';
        this.revokeReturnStatusExcludeJson = '';
        this.revokePaymentStatusIncludeJson = '';
        this.revokePaymentStatusExcludeJson = '';
        this.revokeBranchListIncludeJson = '';
        this.revokeBranchListExcludeJson = '';
        this.allowRevokePositiveAmountOrders = config.allow_revoke_positive_amount_orders || false;

        // Set checkboxes based on calculation_start_date values
        if (this.module.module_config.calculation_start_date.gaining?.date) {
          this.conditionsCheckboxType.push("gaining_calculation_start_date");
        }
        if (this.module.module_config.calculation_start_date.deducting?.date) {
          this.conditionsCheckboxType.push("deducting_calculation_start_date");
        }
        if (this.module.module_config.calculation_start_date.returning?.date) {
          this.conditionsCheckboxType.push("returning_calculation_start_date");
        }

        if (config.conditions) {
          config.conditions.forEach(condition => {
            if (condition.type === "earn_points") {
              this.conditionsCheckboxType.push("earn_points");
            } else if (condition.type === "created_n_days" || condition.type === "completed_n_days") {
              this.conditionsCheckboxType.push("start_time_query");
              this.startTimeCondition = { ...condition };
            } else if (condition.type === "before_created_n_days" || condition.type === "before_completed_n_days") {
              this.conditionsCheckboxType.push("end_time_query");
              this.endTimeCondition = { ...condition };
            } else if (condition.type === "status") {
              this.conditionsCheckboxType.push("order_status_filter");
              this.orderStatusCondition.days = condition.days ?? 1;
              this.orderStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.orderStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "delivery_status") {
              this.conditionsCheckboxType.push("delivery_status_filter");
              this.deliveryStatusCondition.days = condition.days ?? 1;
              this.deliveryStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.deliveryStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "return_status") {
              this.conditionsCheckboxType.push("return_status_filter");
              this.returnStatusCondition.days = condition.days ?? 1;
              this.returnStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.returnStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "payment_status") {
              this.conditionsCheckboxType.push("payment_status_filter");
              this.paymentStatusCondition.days = condition.days ?? 1;
              this.paymentStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.paymentStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "outer_branch_ids") {
              this.conditionsCheckboxType.push("branch_list_filter");
              this.branchListIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.branchListExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "revoke_status") {
              this.conditionsCheckboxType.push("revoke_status_filter");
              this.revokeStatusCondition.days = condition.days ?? 1;
              this.revokeStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.revokeStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "revoke_delivery_status") {
              this.conditionsCheckboxType.push("revoke_delivery_status_filter");
              this.revokeDeliveryStatusCondition.days = condition.days ?? 1;
              this.revokeDeliveryStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.revokeDeliveryStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "revoke_return_status") {
              this.conditionsCheckboxType.push("revoke_return_status_filter");
              this.revokeReturnStatusCondition.days = condition.days ?? 1;
              this.revokeReturnStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.revokeReturnStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "revoke_payment_status") {
              this.conditionsCheckboxType.push("revoke_payment_status_filter");
              this.revokePaymentStatusCondition.days = condition.days ?? 1;
              this.revokePaymentStatusIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.revokePaymentStatusExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            } else if (condition.type === "revoke_outer_branch_ids") {
              this.conditionsCheckboxType.push("revoke_branch_list_filter");
              this.revokeBranchListIncludeJson = JSON.stringify(condition.include || [], null, 2);
              this.revokeBranchListExcludeJson = JSON.stringify(condition.exclude || [], null, 2);
            }
          });
        }
      } catch (error) {
        console.log("error", error);
      }
      this.isFetchingModule = false;
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    goToList() {
      this.$router.push({ name: "Overview" });
    },
    async submit() {
      const result = await this.v$.$validate();
      if (!result) return;

      // 驗證時間範圍
      if (this.isTimeRangeInvalid) {
        this.$swal.fire({
          type: "error",
          text: "起始時間必須小於截止時間",
        }).then(() => {
          setTimeout(() => {
            const targetEl = document.getElementById('start-time-form-group');
            if (targetEl) {
              const rect = targetEl.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetPosition = rect.top + scrollTop - (window.innerHeight / 2);
              window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            }
          }, 300);
        });
        return;
      }

      // 驗證「處理金額非負數的訂單」需要至少設定一項訂單狀態的白名單
      if (this.allowRevokePositiveAmountOrders) {
        const hasValidStatusWhitelist = this.hasNonEmptyArray(this.revokeStatusIncludeJson) ||
          this.hasNonEmptyArray(this.revokeDeliveryStatusIncludeJson) ||
          this.hasNonEmptyArray(this.revokeReturnStatusIncludeJson) ||
          this.hasNonEmptyArray(this.revokePaymentStatusIncludeJson);

        if (!hasValidStatusWhitelist) {
          this.$swal.fire({
            type: "error",
            text: "處理非負數的訂單時，最少需設定一項訂單狀態",
          });
          return;
        }
      }

      const queryConditions = {
        start_time_query: {...this.startTimeCondition},
        end_time_query: {...this.endTimeCondition},
        earn_points: { type: "earn_points", earn_points: true },
        order_status_filter: { type: "status", days: this.orderStatusCondition.days, include: this.parseJsonArraySafe(this.orderStatusIncludeJson), exclude: this.parseJsonArraySafe(this.orderStatusExcludeJson) },
        delivery_status_filter: { type: "delivery_status", days: this.deliveryStatusCondition.days, include: this.parseJsonArraySafe(this.deliveryStatusIncludeJson), exclude: this.parseJsonArraySafe(this.deliveryStatusExcludeJson) },
        return_status_filter: { type: "return_status", days: this.returnStatusCondition.days, include: this.parseJsonArraySafe(this.returnStatusIncludeJson), exclude: this.parseJsonArraySafe(this.returnStatusExcludeJson) },
        payment_status_filter: { type: "payment_status", days: this.paymentStatusCondition.days, include: this.parseJsonArraySafe(this.paymentStatusIncludeJson), exclude: this.parseJsonArraySafe(this.paymentStatusExcludeJson) },
        branch_list_filter: { type: "outer_branch_ids", include: this.parseJsonArraySafe(this.branchListIncludeJson), exclude: this.parseJsonArraySafe(this.branchListExcludeJson) },
        revoke_status_filter: { type: "revoke_status", days: this.revokeStatusCondition.days, include: this.parseJsonArraySafe(this.revokeStatusIncludeJson), exclude: this.parseJsonArraySafe(this.revokeStatusExcludeJson) },
        revoke_delivery_status_filter: { type: "revoke_delivery_status", days: this.revokeDeliveryStatusCondition.days, include: this.parseJsonArraySafe(this.revokeDeliveryStatusIncludeJson), exclude: this.parseJsonArraySafe(this.revokeDeliveryStatusExcludeJson) },
        revoke_return_status_filter: { type: "revoke_return_status", days: this.revokeReturnStatusCondition.days, include: this.parseJsonArraySafe(this.revokeReturnStatusIncludeJson), exclude: this.parseJsonArraySafe(this.revokeReturnStatusExcludeJson) },
        revoke_payment_status_filter: { type: "revoke_payment_status", days: this.revokePaymentStatusCondition.days, include: this.parseJsonArraySafe(this.revokePaymentStatusIncludeJson), exclude: this.parseJsonArraySafe(this.revokePaymentStatusExcludeJson) },
        revoke_branch_list_filter: { type: "revoke_outer_branch_ids", include: this.parseJsonArraySafe(this.revokeBranchListIncludeJson), exclude: this.parseJsonArraySafe(this.revokeBranchListExcludeJson) }
      }

      this.module.module_config.conditions = Object.keys(queryConditions)
        .filter(key => this.conditionsCheckboxType.includes(key))
        .map(key => queryConditions[key])

      this.module.module_config.allow_revoke_positive_amount_orders = this.allowRevokePositiveAmountOrders;

      try {
        this.isSubmmiting = true;
        this.module.is_enabled = this.module.is_enabled ? 1 : 0;

        if (this.isEdit) {
          await moduleApi.updateModule(this.orgId, this.moduleId, this.module);
        }
        else {
          await moduleApi.createModule(this.orgId, this.module);
        }

        this.showSuccessPopup();
      } catch (error) {
        const { status, data } = error.response;
        if (status && status === 422 && data.message) {
          const html = Object.values(data.message)
            .map((m) => m[0])
            .join("<br/>");
          this.$swal.fire({
            type: "error",
            html,
          });
        }
      } finally {
        this.isSubmmiting = false;
      }
    },

    showSuccessPopup() {
      let text = '';
      if (this.isEdit) {
        text = this.module.is_enabled ? "修改成功" : "修改成功，但模組尚未啟用";
      } else {
        text = this.module.is_enabled ? "新增成功" : "新增成功，但模組尚未啟用";
      }

      this.$swal
        .fire({
          type: "success",
          text: text
        })
        .then(() => {
          this.fetchModule();
          this.fetchModulesOfCurrentOrg();
        })
    },
    // 共用防止非法鍵
    preventInvalidNumberKey(e, min) {
      const keys = ['-', '+', 'e', 'E', '.']

      // 阻擋非數字或特殊符號
      if (keys.includes(e.key)) {
        e.preventDefault()
        return
      }

      // 允許數字，檢查輸入後的值
      const input = e.target
      const valueAfterKey =
        input.value.substring(0, input.selectionStart) +
        e.key +
        input.value.substring(input.selectionEnd)

      // 如果輸入後的數字小於 min，阻擋按鍵
      if (Number(valueAfterKey) < min) {
        e.preventDefault()
      }
    },

    // 共用輸入修正 method
    onPositiveIntInput(value, path, min) {
      let num = parseInt(value, 10)

      if (!Number.isInteger(num) || num < min) {
        deepSet(this, path, min)
        return
      }

      deepSet(this, path, num)
    },
    dayOptions(month) {
      if (!month) return [];

      const currentYear = new Date().getFullYear();
      const daysInMonth = new Date(currentYear, month, 0).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => ({ value: i + 1, text: i + 1 }));
    },
    updatePeriodEnd() {
      const { month, day } = this.computedPeriodEnd;
      this.module.module_config.expiration.period_end_month = month;
      this.module.module_config.expiration.period_end_day = day;

      this.validateExpiryDate();
    },
    validateExpiryDate() {
      const offsetYears = this.module.module_config.expiration.expiry_offset_years;

      // 若過期年度為 0 年後，過期日需晚於年度終止日，其餘不受限
      if (offsetYears !== 0) return;
      const periodEndMonth = this.module.module_config.expiration.period_end_month;
      const periodEndDay = this.module.module_config.expiration.period_end_day;
      const expiryMonth = this.module.module_config.expiration.expiry_month;
      const expiryDay = this.module.module_config.expiration.expiry_day;

      const periodEndDate = new Date(new Date().getFullYear(), periodEndMonth - 1, periodEndDay);
      const expiryDate = new Date(new Date().getFullYear(), expiryMonth - 1, expiryDay);

      if (expiryDate <= periodEndDate) {
        this.module.module_config.expiration.expiry_month = periodEndMonth;
        this.module.module_config.expiration.expiry_day = periodEndDay;
      }
    },
    /**
     * 整數輸入處理，支援 array key
     */
    onPositiveIntInputArray(value, path, min) {
      let num = parseInt(value, 10)

      if (!Number.isInteger(num) || num < min) {
        this.setByPathWithArrayKey(path, min)
        return
      }

      this.setByPathWithArrayKey(path, num)
    },
    /**
     * @param {string} jsonString - JSON 字串
     * @returns {Object|null} 解析後的物件，或 null（解析失敗）
     */
    parseJsonSafe(jsonString) {
      if (!jsonString || jsonString.trim() === '') {
        return null
      }
      try {
        return JSON.parse(jsonString)
      } catch (e) {
        return null
      }
    },
    /**
     * 安全解析 JSON 陣列字串
     * @param {string} jsonString - JSON 陣列字串
     * @returns {Array} 解析後的陣列，或空陣列（解析失敗）
     */
    parseJsonArraySafe(jsonString) {
      if (!jsonString || jsonString.trim() === '') {
        return []
      }
      try {
        const parsed = JSON.parse(jsonString)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    /**
     * 檢查 JSON 陣列字串是否為非空陣列
     * @param {string} jsonString - JSON 陣列字串
     * @returns {boolean} 是否為非空陣列
     */
    hasNonEmptyArray(jsonString) {
      const arr = this.parseJsonArraySafe(jsonString);
      return arr.filter(item => item !== null && item !== undefined && String(item).trim() !== '').length > 0;
    }
  },
};
</script>

<style lang="scss" scoped>

.customer-level-grid {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto 1fr;
  gap: 0.5rem;
  align-items: center;
}

.customer-level-item {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  padding: 0.5rem 0;
  white-space: nowrap;

  input.form-control {
    max-width: 200px;
  }
}

::v-deep .spinner-transparent > .spinner-border {
  border-color: transparent;
}

.card {
  border: 1px solid #dee2e6;
}

.card-header {
  background-color: #f8f9fa;
}
</style>
